module.exports = __webpack_public_path__ + "img/G28-new-zealand.580ad3a8.png";